import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useMemo } from 'react';
import CropperJS from 'cropperjs';
import { tuple } from '../_utils/type'; // crop 形成新的裁剪框
// move 图片可移动
// none 都不能移动

export var DragModeTypes = tuple('crop', 'move', 'none');
var Cropper = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var containerRef = useRef(null);
  var imgRef = useRef(null);
  var cropperRef = useRef(null);
  useImperativeHandle(forwardedRef, function () {
    return {
      getImage: getImage,
      reset: reset,
      rotate: rotate,
      zoom: zoom,
      replace: replace,
      cropper: cropperRef
    };
  });
  var className = props.className,
      _props$imgSrc = props.imgSrc,
      imgSrc = _props$imgSrc === void 0 ? '' : _props$imgSrc,
      dragMode = props.dragMode,
      viewMode = props.viewMode,
      aspectRatio = props.aspectRatio,
      _props$modal = props.modal,
      modal = _props$modal === void 0 ? true : _props$modal,
      _props$zoomOnWheel = props.zoomOnWheel,
      zoomOnWheel = _props$zoomOnWheel === void 0 ? true : _props$zoomOnWheel,
      _props$cropBoxMovable = props.cropBoxMovable,
      cropBoxMovable = _props$cropBoxMovable === void 0 ? true : _props$cropBoxMovable;
  var options = useMemo(function () {
    return {
      aspectRatio: aspectRatio,
      viewMode: viewMode,
      responsive: false,
      restore: false,
      zoomOnWheel: zoomOnWheel,
      dragMode: dragMode,
      cropBoxMovable: cropBoxMovable,
      modal: modal,
      autoCropArea: 0.5
    };
  }, [aspectRatio, viewMode, zoomOnWheel, dragMode, modal, cropBoxMovable]);
  useEffect(function () {
    if (!imgRef.current) return;
    if (!imgSrc) return;

    if (cropperRef.current) {
      cropperRef.current.destroy();
    }

    imgRef.current.onload = function () {
      var img = imgRef.current;
      cropperRef.current = new CropperJS(img, options);
    };

    return function () {
      if (cropperRef.current) {
        cropperRef.current.destroy();
      }
    };
  }, [imgSrc, options]);
  useEffect(function () {
    return function () {
      if (cropperRef.current) {
        cropperRef.current.destroy();
      }
    };
  }, []);

  var getImage = function getImage() {
    return new _Promise(function (resolve) {
      if (!cropperRef.current) return resolve(null);
      cropperRef.current.getCroppedCanvas().toBlob(function (blob) {
        var _context;

        if (!blob) return resolve(null);
        resolve(new File([blob], "".concat(_sliceInstanceProperty(_context = Math.random().toString(36)).call(_context, -8), ".png"), {
          type: blob.type
        }));
      });
    });
  };

  var reset = function reset() {
    if (!cropperRef.current) return;
    cropperRef.current.reset();
  };

  var rotate = function rotate() {
    if (!cropperRef.current) return;
    cropperRef.current.rotate(-90);
  };

  var zoom = function zoom(num) {
    if (!cropperRef.current) return;
    cropperRef.current.zoom(num);
  };

  var replace = function replace(src) {
    if (!cropperRef.current) return;
    cropperRef.current.replace(src);
  };

  var imgStyle = {
    display: 'none'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    style: imgStyle,
    src: imgSrc
  }));
});
export default Cropper;